import { render, staticRenderFns } from "./bg-state.vue?vue&type=template&id=04e5068e"
import script from "./bg-state.vue?vue&type=script&lang=js"
export * from "./bg-state.vue?vue&type=script&lang=js"
import style0 from "./bg-state.vue?vue&type=style&index=0&id=04e5068e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports